import { DEV } from "solid-js"
import { modifyMutable, produce } from "solid-js/store"
import { isServer } from "solid-js/web"
import { parse, safeParse } from "valibot"
import type { Engine } from "../../engine/Engine.type"
import { hasLocalStorage } from "./HasLocalStorage"
import { SavedGamePayloadSchema, type SavedGamePayload } from "./SavedGamePayload.type"

export const LocalStorageGameName = 'st1_g0'

export function localStorageGameExists() {
  return hasLocalStorage && !!localStorage.getItem(LocalStorageGameName)
}

export async function saveGameToLocalStorage(engine: Engine): Promise<void> {
  const payload: SavedGamePayload = {
    state: engine.state,
    actionLogs: engine.actionLogs,
  }
  const validatedPayload = parse(SavedGamePayloadSchema, payload)
  const jsonString = JSON.stringify(validatedPayload)
  localStorage.setItem(LocalStorageGameName, jsonString)
}

export enum LoadGameFromLocalStorageResult {
  Success,
  NoGameFound,
  ServerDoesNotHaveLocalStorage,
  // InvalidGameFound,
}

export async function loadGameFromLocalStorage(engine: Engine): Promise<LoadGameFromLocalStorageResult> {
  if (isServer) {
    return LoadGameFromLocalStorageResult.ServerDoesNotHaveLocalStorage
  }
  const jsonString = localStorage.getItem(LocalStorageGameName)
  const jsonValue = jsonString ? JSON.parse(jsonString) : null
  if (!jsonValue) {
    return LoadGameFromLocalStorageResult.NoGameFound
  }
  if (DEV) {
    const result = safeParse(SavedGamePayloadSchema, jsonValue)
    if (!result.success) {
      console.log('jsonValue', jsonValue)
      console.error('Issues:', result.issues)
    }
  }
  const parseResult = parse(SavedGamePayloadSchema, jsonValue)
  modifyMutable(engine, produce((engine: Engine) => {
    engine.state = parseResult.state
    engine.actionLogs = parseResult.actionLogs
  }))
  return LoadGameFromLocalStorageResult.Success
}